/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const CommPhoneFill: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      d='M12.1005 15.3839C10.5936 14.6611 9.37661 13.451 8.64782 11.9505C8.59552 11.8415 8.57213 11.721 8.57988 11.6005C8.58763 11.48 8.62626 11.3634 8.69208 11.262L10.1204 10.096C10.7686 9.56678 10.9669 8.66267 10.5992 7.91207L9.14821 4.94967C8.80847 4.25604 8.05871 3.84535 7.3135 4.05481C6.43662 4.30127 5.5064 4.69213 5.05973 5.19804C4.37697 5.97133 4.00023 6.96615 4 7.99634C4 11.1799 5.2685 14.2331 7.52645 16.4842C9.7844 18.7353 12.8468 20 16.0401 20C17.0734 19.9998 18.0712 19.6242 18.8469 18.9435C19.3152 18.5324 19.6853 17.7337 19.9339 16.9403C20.1913 16.1188 19.6693 15.3008 18.8503 15.0286L15.775 14.0066C15.1921 13.8129 14.5505 13.9278 14.0717 14.3116L12.7999 15.3309C12.6979 15.3995 12.5798 15.4405 12.4572 15.4498C12.3346 15.4591 12.2116 15.4364 12.1005 15.3839Z'
      fill='currentColor'
    />
  </React.Fragment>
)
